import { DataTransform } from "@nemuru-eng/js-api-client";
import { documentTypes } from "../../../components/modules/kyc/shared/config";
import { spainIdType } from "../../validations";
import { FormatDateMapper } from "../FormatDateMapper";
import { addressMapper } from "../../../components/modules/kyc/shared/AutocompleteAddressHeadless/components/GoogleMapsAutocomplete/mappers/addressMapper";

export const DocumentIdMapper = {
  reverseMap(data) {
    return {
      document_type: documentTypes.find(
        (document) => document.id === data.documentType
      ).patchValueId,
      document_expeditor: data.documentExpeditor,
      nationality: data.nationality,
      document_number: data.documentNumber.trim().toUpperCase(),
      expiration:
        spainIdType(data.documentNumber) === "nie"
          ? FormatDateMapper.dehydrate("01/01/2100")
          : FormatDateMapper.dehydrate(data.expiration),
      full_name_first_name: data.firstName,
      full_name_last_name: data.lastName,
      gender: data.gender,
      address: DataTransform.camelToSnake(addressMapper.toDto(data.address)),
      birth_date: FormatDateMapper.dehydrate(data.birthdate), //"1984-07-01T11:19:05+02:00",
      birth_place_address: `${data.birthProvince.toUpperCase()} ${data.birthCity.toUpperCase()}`,
    };
  },
};
